// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"170":"2bb8138a","185":"25cced4e","880":"d7af2f51"}[chunkId] + ".chunk.css";
};